const ACCENT_MAP: Record<string, string> = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ç: 'c',
  ñ: 'n',
  À: 'a',
  Á: 'a',
  Â: 'a',
  Ã: 'a',
  Ä: 'a',
  È: 'e',
  É: 'e',
  Ê: 'e',
  Ë: 'e',
  Ì: 'i',
  Í: 'i',
  Î: 'i',
  Ï: 'i',
  Ò: 'o',
  Ó: 'o',
  Ô: 'o',
  Õ: 'o',
  Ö: 'o',
  Ù: 'u',
  Ú: 'u',
  Û: 'u',
  Ü: 'u',
  Ç: 'c',
  Ñ: 'n',
};

const ACCENT_REGEX = /[àáâãäèéêëìíîïòóôõöùúûüçñÀÁÂÃÄÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÇÑ]/g;
const PUNCTUATION_REGEX = /[.\-_/()\\,;:!@#$%^&*+=<>?'"[\]{}|~`]+/g;
const MULTI_SPACE_REGEX = /\s+/g;

function removeAccents(text: string): string {
  return text.replace(ACCENT_REGEX, (char) => ACCENT_MAP[char] || char);
}

export function normalizeSearchQuery(query: string): string {
  return removeAccents(query.toLowerCase())
    .replace(PUNCTUATION_REGEX, '')
    .replace(MULTI_SPACE_REGEX, ' ')
    .trim();
}

const DASH_VARIANTS_REGEX = /[\u2010-\u2015\u2212]/g;

/**
 * Accent/dash-insensitive normalization with a 1:1 character mapping, so an
 * index found in the normalized string still points at the same character of
 * the source string. Unlike `normalizeSearchQuery` it keeps punctuation and
 * whitespace — required by index-based highlighting.
 */
export function normalizeSearchPreservingIndexes(text: string): string {
  return removeAccents(text.toLowerCase()).replace(DASH_VARIANTS_REGEX, '-');
}
